export type SubmenuType = {
  path: string;
  i18NameKey?: string;
  backPath?: string;
  subMenu?: Record<string, SubmenuType>;
};

interface PageDescription {
  path: string;
  iconName?: string;
  i18NameKey: string;
  backPath?: string;
  subMenu?: Record<string, SubmenuType>;
}

const addressCheckPagePath = '/check';
const investigationsPagePath = '/investigations';
const traceInvestigationsPagePath = '/trace-investigations';
const authPagesPaths = {
  AMLCHECK_PAGE_PATH: addressCheckPagePath,
  INVESTIGATIONS_PAGE_PATH: investigationsPagePath,
  TRACE_INVESTIGATIONS_PAGE_PATH: traceInvestigationsPagePath,
  PROFILE_PAGE_PATH: '/profile',
  NOTIFICATIONS_PAGE_PATH: '/notifications',
  TARIFFS_PAGE_PATH: '/tariffs',
  DETAILS_PAGE_PATH: '/details',
  INVESTIGATION_DETAILS_PAGE_PATH: '/investigations/details',
  TRACE_INVESTIGATION_DETAILS_PAGE_PATH: `${traceInvestigationsPagePath}/details`,
  CONTACT_PAGE_PATH: '/contact',
  COMPLIANCE_DASHBOARD_PAGE_PATH: '/compliance-dashboard',
  COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_PAGE_PATH:
    '/compliance-dashboard/transaction-monitoring',
  COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_OVERVIEW_PAGE_PATH:
    '/compliance-dashboard/transaction-monitoring/overview',
  COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_USERS_PAGE_PATH:
    '/compliance-dashboard/transaction-monitoring/users',
  COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_ALERTS_SETTINGS_PAGE_PATH:
    '/compliance-dashboard/transaction-monitoring/alerts/settings',
  COMPLIANCE_DASHBOARD_ADDRESSES_MONITORING_PAGE_PATH:
    '/compliance-dashboard/addresses-monitoring',
};

const navigationPages: Record<string, PageDescription> = {
  DASHBOARD: {
    path: addressCheckPagePath,
    iconName: 'aml',
    i18NameKey: 'translation.dashboard',
    subMenu: {
      CHECK_ADDRESS: {
        path: addressCheckPagePath,
      },
      INVESTIGATIONS: {
        path: investigationsPagePath,
        i18NameKey: 'translation.investigations',
      },
    },
  },
  TRACE_INVESTIGATIONS: {
    path: authPagesPaths.TRACE_INVESTIGATIONS_PAGE_PATH,
    iconName: 'ai',
    i18NameKey: 'translation.ai_investigation',
  },
  TRACE_INVESTIGATION_DETAILS: {
    path: authPagesPaths.TRACE_INVESTIGATION_DETAILS_PAGE_PATH,
    iconName: 'ai',
    i18NameKey: 'translation.ai_investigation',
    backPath: traceInvestigationsPagePath,
  },
  INVESTIGATIONS: {
    path: authPagesPaths.INVESTIGATIONS_PAGE_PATH,
    iconName: 'investigations',
    i18NameKey: 'translation.investigations',
  },
  TARIFFS: {
    path: authPagesPaths.TARIFFS_PAGE_PATH,
    iconName: 'billing',
    i18NameKey: 'translation.billing',
  },
  PROFILE: {
    path: authPagesPaths.PROFILE_PAGE_PATH,
    iconName: 'profile',
    i18NameKey: 'translation.profile',
  },
  NOTIFICATIONS: {
    path: authPagesPaths.NOTIFICATIONS_PAGE_PATH,
    iconName: 'notification',
    i18NameKey: 'translation.notifications.title',
  },
  COMPLIANCE_DASHBOARD: {
    path: authPagesPaths.COMPLIANCE_DASHBOARD_PAGE_PATH,
    iconName: 'compliance-dashboard',
    i18NameKey: 'translation.monitoring',
    subMenu: {
      TRANSACTION_MONITORING: {
        path: authPagesPaths.COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_PAGE_PATH,
        i18NameKey: 'translation.transaction_monitoring',
        subMenu: {
          OVERVIEW: {
            path: authPagesPaths.COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_OVERVIEW_PAGE_PATH,
            i18NameKey: 'translation.overview',
          },
          USERS: {
            path: authPagesPaths.COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_USERS_PAGE_PATH,
            i18NameKey: 'translation.users',
          },
          ALERTS_SETTINGS: {
            path: authPagesPaths.COMPLIANCE_DASHBOARD_TRANSACTION_MONITORING_ALERTS_SETTINGS_PAGE_PATH,
            i18NameKey: 'translation.alerts_settings',
          },
        },
      },
      ADDRESSES_MONITORING: {
        path: authPagesPaths.COMPLIANCE_DASHBOARD_ADDRESSES_MONITORING_PAGE_PATH,
        i18NameKey: 'translation.addresses_monitoring',
      },
    },
  },
  DETAILS: {
    path: authPagesPaths.DETAILS_PAGE_PATH,
    iconName: 'details',
    i18NameKey: 'translation.details',
    backPath: '/check',
  },
  INVESTIGATION_DETAILS: {
    path: authPagesPaths.INVESTIGATION_DETAILS_PAGE_PATH,
    iconName: 'details',
    i18NameKey: 'translation.details',
    backPath: investigationsPagePath,
  },
};

export {
  navigationPages,
  addressCheckPagePath,
  investigationsPagePath,
  authPagesPaths,
};
export type { PageDescription };
